import { render, staticRenderFns } from "./KmBanners.vue?vue&type=template&id=babe1a36&scoped=true&"
import script from "./KmBanners.vue?vue&type=script&lang=js&"
export * from "./KmBanners.vue?vue&type=script&lang=js&"
import style0 from "./KmBanners.vue?vue&type=style&index=0&id=babe1a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babe1a36",
  null
  
)

export default component.exports